import { cliSimpleGit } from '../cli-simple-git.js';

/** Create `branch` at `startRef`, or move it when it already exists. */
export async function gitCreateOrUpdateBranch(
  repoPath: string,
  branch: string,
  startRef: string,
  options?: { branchCheckedOutWorktreePath?: string },
): Promise<void> {
  const ref = startRef.trim() || 'HEAD';
  const checkedOutWorktreePath = options?.branchCheckedOutWorktreePath?.trim();

  if (checkedOutWorktreePath) {
    const checkoutGit = cliSimpleGit(checkedOutWorktreePath);
    await checkoutGit.checkout(['-f', branch]);
    await checkoutGit.reset(['--hard', ref]);
    return;
  }

  const git = cliSimpleGit(repoPath);
  await git.raw(['branch', '-f', branch, ref]);
}
